import { useCallback, useEffect, useState } from 'react';
import AdminPageHeader from '../components/AdminPageHeader';
import AdminTable from '../components/AdminTable';
import LoadStatus from '../components/LoadStatus';
import { getContacts } from './contactApi';

const COLUMNS = [
    { key: 'created_at', label: '접수일', className: 'nowrap muted' },
    { key: 'company', label: '지역/회사명', className: 'nowrap' },
    { key: 'manager', label: '담당자', className: 'nowrap', render: row => <>{row.manager_name}<br /><span className="muted">{row.email}</span></> },
    { key: 'phone', label: '연락처', className: 'nowrap' },
    { key: 'content', label: '문의 내용', className: 'wide', render: row => <span className="muted">{row.content}</span> },
];

// 상세 화면 경로를 만든다.
function toDetailPath(row) {
    return `/admin/contacts/${encodeURIComponent(row.id)}`;
}

// 외부인이 Contact 화면에서 남긴 기업 문의 목록 화면.
export default function ContactListPage() {
    const [contacts, setContacts] = useState(null);
    const [error, setError] = useState('');

    // 기업 문의 목록을 불러온다.
    const load = useCallback(async () => {
        setError('');
        setContacts(null);
        try {
            setContacts(await getContacts());
        } catch (loadError) {
            setError(loadError.message);
        }
    }, []);

    useEffect(() => { load(); }, [load]);

    return (
        <>
            <AdminPageHeader title="기업 문의" count={contacts?.length} />
            {contacts ? <AdminTable columns={COLUMNS} rows={contacts} rowKey="id" getRowLink={toDetailPath} /> : <LoadStatus error={error} onRetry={load} />}
        </>
    );
}
